// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { ResponseMessageSchema, StatusSchema } from "./utilitySchemas";

export const AuditActorTypeSchema = z.enum(
    ["USER", "EVALION", "STRIPE", "UNKNOWN"]
);
export type AuditActorType = z.infer<typeof AuditActorTypeSchema>;

export const UserFriendlyAuditLogEventTypeSchema = z.enum([
    "Request",
    "UserManagement",
    "Entity"
]);
export type UserFriendlyAuditLogEventType = z.infer<
    typeof UserFriendlyAuditLogEventTypeSchema
>;

export const UserFriendlyAuditLogActionTypeSchema = z.enum([
    "service_provider",
    "status_change",
    "reassignment",
    "request_created",
    "payment_status_change",
    "initial_assessment_uploaded",
    "initial_assessment_sent",
    "appraisal_uploaded",
    "appraisal_sent",
    "payment_link_changed",
    "payment_link_sent",
    "requester_email_changed",
    "request_owner_changed",
    "discount_code_changed",
    "manual_invoice_reference_changed",
    "entity_priority_changed",
    "request_flag_changed",
    "external_ppa_summary_updated",
    "viewing_changed",
]);

export type UserFriendlyAuditLogActionType = z.infer<
    typeof UserFriendlyAuditLogActionTypeSchema
>;

export const UserFriendlyAuditLogOrderSchema = z.enum(["asc", "desc"]);

export const UserFriendlyAuditLogQuerySchema = z
    .object({
        limit: z.coerce.number().int().positive().max(200).default(100),
        offset: z.coerce.number().int().min(0).default(0),
        order: UserFriendlyAuditLogOrderSchema.default("desc"),
        filter: z.object({ 
            activity: z.object({
                search: z.string().trim().min(1).optional(),
                eventLogType: UserFriendlyAuditLogEventTypeSchema.optional(),
                actionType: UserFriendlyAuditLogActionTypeSchema.optional(),
                evalionId: z.string().trim().min(1).optional(),
                isExternal: z
                    .union([z.boolean(), z.literal("true"), z.literal("false")])
                    .optional()
                    .transform((v) =>
                        v === undefined ? undefined : v === true || v === "true",
                    ),
                dateRange: z
                    .object({
                        from: z.coerce.date().optional(),
                        to: z.coerce.date().optional(),
                    })
                    .optional(),
            }).optional()
        }).optional(),
    })
    .refine(
        (data) => {
            const from = data.filter?.activity?.dateRange?.from;
            const to = data.filter?.activity?.dateRange?.to;
            if (from && to) {
                return from <= to;
            }
            return true;
        },
        {
            message: "The 'from' date must be earlier than the 'to' date.",
            path: ["filter", "activity", "dateRange", "from"],
        },
    );

export type UserFriendlyAuditLogQuery = z.infer<typeof UserFriendlyAuditLogQuerySchema>;

export const UserFriendlyAuditLogListItemSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.coerce.date(),
    eventLogType: UserFriendlyAuditLogEventTypeSchema,
    actionType: UserFriendlyAuditLogActionTypeSchema,
    changedByUserId: z.number().int().nullable(),
    changedByUser: z
        .object({
            id: z.number().int(),
            firstName: z.string(),
            lastName: z.string(),
            email: z.string(),
        })
        .nullable(),
    evalionId: z.string(),
    isExternal: z.boolean(),
    scope: UserFriendlyAuditLogEventTypeSchema,
    scopeId: z.string(),
    eventLabel: z.string(),
    before: z.string(),
    after: z.string(),
})

export type UserFriendlyAuditLogListItem = z.infer<typeof UserFriendlyAuditLogListItemSchema>;

export const UserFriendlyAuditLogsResponseSchema = z.object({
    status: StatusSchema,
    message: ResponseMessageSchema.optional(),
    data: z.object({
        listing: z.array(UserFriendlyAuditLogListItemSchema),
    }),
})

export type UserFriendlyAuditLogsResponse = z.infer<typeof UserFriendlyAuditLogsResponseSchema>;

export const UserFriendlyAuditLogReadStateSchema = z.object({
    userId: z.number(),
    lastReadAt: z.string(),
});

export type UserFriendlyAuditLogReadState = z.infer<
    typeof UserFriendlyAuditLogReadStateSchema
>;

export const UserFriendlyAuditLogReadStatePayloadSchema = z.object({
    lastReadAt: z.string(),
});

export type UserFriendlyAuditLogReadStatePayload = z.infer<
    typeof UserFriendlyAuditLogReadStatePayloadSchema
>;

export const UserFriendlyAuditLogReadStateResponseSchema = z.object({
    status: StatusSchema,
    message: ResponseMessageSchema.optional(),
    data: z.object({
        lastReadAt: z.string().nullable(),
        totalCount: z.number().int().nonnegative(),
        unreadCount: z.number().int().nonnegative(),
    }),
});

export type UserFriendlyAuditLogReadStateResponse = z.infer<
    typeof UserFriendlyAuditLogReadStateResponseSchema
>;
